import React, { FC }             from "react";
import { useDispatch, useStore } from "react-redux";
import { Button, Icon } from "semantic-ui-react";
import UpdateStaff      from "../../../application/usecase/staff/UpdateStaff";
import Staff            from "../../../domain/staff/Staff";

const StaffUpdateButton: FC = () => {
  const staff: Staff = useStore().getState().staff;
  const updateStaff: UpdateStaff = new UpdateStaff(useDispatch());
  return (
    <>
      <Button
        icon
        labelPosition="left"
        positive
        onClick={ () => updateStaff.execute(staff) }
      >
        <Icon name="save"/>保存する
      </Button>
    </>
  );
};

export default StaffUpdateButton;
